import { apps } from './app-constant';

/**
 * Mappa selector widget → appId proprietario, usata da WidgetBorderStylePipe.
 * Il DashboardWidgetDto del Workspace non espone ownerAppId: lo deriviamo dal
 * selector (i selettori sono fissi, vedi dynamic-widgets.component.html).
 * Fallback: apps.amSuite (→ border-orange dal pipe).
 */
export const SELECTOR_TO_OWNER_APP: Record<string, string> = {
  'smart-box': apps.amSuite,
  'crm-last-parties': apps.crm,
  'crm-more-used': apps.crm,
  'crm-party-search': apps.crm,
  'calendar-party-activities': apps.calendar,
  'calendar-activity-graphstate': apps.calendar,
  'calendar-activity-typologygraph': apps.calendar,
  'calendar-activity-hoursgraph': apps.calendar,
  'calendar-party-projects': apps.calendar,
  'templates-last-used': apps.amSuite,
  'cpr-myrequest': apps.causalRequest,
  'cpr-waiting-request': apps.causalRequest,
  'clocking-approve-entries': apps.clocking,
  'attendanceSheet-lul-summary': apps.attendanceSheet,
  'dialog-sended': apps.dialog,
  'party-accruals-summary': apps.attendanceSheet,
  'employee-last-documents': apps.employeeArchive,
  'last-documents': apps.employeeArchive,
  'party-clocking-day': apps.clocking,
  'partyprofile-expiredcompetence': apps.partyProfile,
  'my-refunded-cost': apps.refundedCosts,
  'approver-refunded-cost': apps.refundedCosts,
};

export function resolveOwnerAppId(selector: string | null | undefined): string {
  if (!selector) return apps.amSuite;
  return SELECTOR_TO_OWNER_APP[selector] ?? apps.amSuite;
}
